import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const REVERT_REPLACE_DISH_TYPE_MUTATION = gql`
  mutation revertReplaceDishType($replaceToken: String!) {
    revertReplaceDishType(replaceToken: $replaceToken) {
      results {
        ...DishTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REVERT_REPLACE_DISH_TYPE_MUTATION
